export const categoriesFormsModel =[
	{
		id: "mensuration",
		label: "Mensuração",
		size: 4
	},
	{
		id: "menagement",
		label: "Gestão",
		size: 4
	},
	{
		id: "comunication",
		label: "Engajamento e Comunicação",
		size: 4
	},
];


// WEBPACK FOOTER //
// src/models/lib/tabs/categoriesFormsModel.js